export default __webpack_public_path__ + "static/media/innova.ec0e8bb9.png";